import { Avatar } from '@material-ui/core';
import { MailRounded, PhoneRounded, RoomRounded } from '@material-ui/icons';
import { getInfosDashboard } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { formatPhoneNumber } from 'react-phone-number-input';

const RecordSidebarHeader = ({ applicant, contractId, height = 60, width = 60, className }) => {
  const { css, global, classes, cx } = useStyles(styles);

  const { data: infos = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', applicant?.id],
    variables: { id: applicant?.id },
  });

  return (
  <div className={global.frac}>
    {infos?.profile?.profileImageUrl ? (
      <Avatar className={css({ height, width, ...className })} src={infos?.profile?.profileImageUrl} />
    ) : (
      <Avatar className={css({ height, width, ...className })}>
        {applicant?.lastname?.substr(0, 1)} {applicant?.firstname?.substr(0, 1)}
      </Avatar>
    )}
    <div>
      <div className={cx(global.title, classes.name, css({ marginBottom: "4px" }))}>
        {applicant?.firstname} {applicant?.lastname} <span className={classes.contractSpan}>{`ID contrat : ${contractId || "Non synchronisé"}`}</span>
      </div>
      <div className={cx(classes.name, global.infoText, global.frac)} >
        <MailRounded className={global.infoIcon} /> 
        <div>{applicant?.email}</div>
      </div>
      <div className={cx(classes.name, global.infoText, global.frac)} >
        <PhoneRounded className={global.infoIcon} /> 
        <div>{applicant?.phone ? formatPhoneNumber(applicant?.phone) : "Non renseigné"}</div>
      </div>
    </div>
  </div>
  );
};

const styles = ({ spacing }) => ({
  name: {
    marginLeft: spacing(2),
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
    fontSize: '20px',
  },
  contractSpan: {
    marginLeft: spacing(1),
    backgroundColor: "#0060F9",
    borderRadius: '5px',
    padding: '0px 5px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '11px',
    color: "white"
  }
});

export default RecordSidebarHeader;
